import { render, staticRenderFns } from "./ReverseLogisticsDetail.vue?vue&type=template&id=77efa8ca"
import script from "./ReverseLogisticsDetail.vue?vue&type=script&lang=js"
export * from "./ReverseLogisticsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports